module.exports = __webpack_public_path__ + "img/mascotas.2b313fba.svg";